import {
  faAddressCard,
  faAnglesDown,
  faAnglesUp,
  faAngleLeft,
  faAngleRight,
  faArchive,
  faArrowUp,
  faArrows,
  faAsterisk,
  faBadgeCheck,
  faBars,
  faBold,
  faBook,
  faBookmark,
  faBullseyeArrow,
  faCalendar,
  faCaretDown,
  faCaretRight,
  faCheck,
  faCheckSquare,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faClipboardListCheck,
  faClock,
  faCommentsAlt,
  faCrown,
  faDiamondExclamation,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEdit,
  faEllipsisVertical,
  faEnvelope,
  faEquals,
  faExclamation,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFileCheck,
  faFileDownload,
  faFileExport,
  faFileSignature,
  faFolder,
  faFolderOpen,
  faFolderTimes,
  faFolderTree,
  faGear,
  faGripVertical,
  faHighlighter,
  faHouse,
  faIdCard,
  faKey,
  faLink,
  faList,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMapMarkerPlus,
  faMinus,
  faMinusSquare,
  faPaperclip,
  faPen,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPrint,
  faQuestionSquare,
  faQuoteRight,
  faRedo,
  faRedoAlt,
  faRotateRight,
  faShare,
  faSlidersH,
  faSlidersV,
  faSlidersVSquare,
  faSpinnerThird,
  faStepBackward,
  faStepForward,
  faStop,
  faStopCircle,
  faTasks,
  faThumbsDown,
  faThumbsUp,
  faTrash,
  faTrashCan,
  faUndoAlt,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserEdit,
  faUserFriends,
  faUserShield,
  faUsers,
  faXmark,
} from '@awesome.me/kit-da13514c94/icons/classic/solid'

export const solidLibrary = [
  faAddressCard,
  faAnglesDown,
  faAnglesUp,
  faAngleLeft,
  faAngleRight,
  faArchive,
  faArrowUp,
  faArrows,
  faAsterisk,
  faBadgeCheck,
  faBars,
  faBold,
  faBook,
  faBookmark,
  faBullseyeArrow,
  faCalendar,
  faCaretDown,
  faCaretRight,
  faCheck,
  faCheckSquare,
  faChevronDoubleLeft,
  faChevronDoubleRight,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleCheck,
  faCircleExclamation,
  faCircleInfo,
  faCircleQuestion,
  faCircleXmark,
  faClipboardListCheck,
  faClock,
  faCommentsAlt,
  faCrown,
  faDiamondExclamation,
  faDownLeftAndUpRightToCenter,
  faDownload,
  faEdit,
  faEllipsisVertical,
  faEnvelope,
  faEquals,
  faExclamation,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFileCheck,
  faFileDownload,
  faFileExport,
  faFileSignature,
  faFolder,
  faFolderOpen,
  faFolderTimes,
  faFolderTree,
  faGear,
  faGripVertical,
  faHighlighter,
  faHouse,
  faIdCard,
  faKey,
  faLink,
  faList,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMapMarkerPlus,
  faMinus,
  faMinusSquare,
  faPaperclip,
  faPen,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPrint,
  faQuestionSquare,
  faQuoteRight,
  faRedo,
  faRedoAlt,
  faRotateRight,
  faShare,
  faSlidersH,
  faSlidersV,
  faSlidersVSquare,
  faSpinnerThird,
  faStepBackward,
  faStepForward,
  faStop,
  faStopCircle,
  faTasks,
  faThumbsDown,
  faThumbsUp,
  faTrash,
  faTrashCan,
  faUndoAlt,
  faUpRightAndDownLeftFromCenter,
  faUser,
  faUserEdit,
  faUserFriends,
  faUserShield,
  faUsers,
  faXmark,
]
